import { css, type Theme } from "@emotion/react";

import * as docsTable from "@/styles/emotionStyles/docsTable";

export const scrollWrapper = docsTable.scrollWrapper;

export const table = (theme: Theme) =>
  css(docsTable.table, {
    backgroundColor: theme.system.backgroundMuted,
  });

export const headerCell = (theme: Theme) =>
  css(docsTable.cellText, {
    border: `1px solid ${theme.system.borderBase}`,
    padding: "0.5rem",
    textAlign: "left",
  });

export const cell = (theme: Theme) =>
  css(docsTable.cellText, {
    border: `1px solid ${theme.system.borderBase}`,
    padding: "0.5rem",
  });
